import type { Locale } from '@ebu/contracts';
import { SelectField } from '@ebu/ui';
import { LANGUAGE_ENDONYMS, useI18n } from '../../i18n/i18n';
import { useGuest } from '../guest/guest-state';

/**
 * Country/broadcaster and language selectors. The language list is the selected broadcaster's
 * supported locales, so the visitor never picks a language the configuration cannot serve.
 * Broadcaster names come from the server configuration and say "(fictional demo member)". The
 * broadcaster's accent shows on the top bar's edge and on the island's tower flag.
 */
export function BroadcasterControls() {
  const { t } = useI18n();
  const { broadcasters, broadcaster, locale, setBroadcaster, setLocale } = useGuest();

  if (broadcasters.status !== 'ready' || !broadcaster) return null;

  return (
    <div className="broadcaster-controls">
      <SelectField
        compact
        icon="broadcaster"
        label={t('shell.broadcaster')}
        value={broadcaster.id}
        options={broadcasters.data.map((b) => ({ value: b.id, label: b.displayName }))}
        onChange={setBroadcaster}
      />
      <SelectField<Locale>
        compact
        icon="language"
        label={t('shell.language')}
        value={locale}
        options={broadcaster.supportedLocales.map((l) => ({
          value: l,
          label: LANGUAGE_ENDONYMS[l],
          lang: l,
        }))}
        onChange={setLocale}
      />
    </div>
  );
}
